import { Box, Link, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { BLUE_TEXT, INTER, NAVY, PAGE_BACKGROUND, POPPINS, SLATE, SUPPORT_EMAIL, publicCardSx } from '../style/verbaScholaPublicStyles';
import { VerbaScholaPublicHeader } from './VerbaScholaPublicChrome';

export const accountLinkSx = { fontFamily: INTER, fontSize: 14, fontWeight: 600, color: BLUE_TEXT } as const;
export const accountBodySx = { fontFamily: INTER, fontSize: 15, lineHeight: 1.6, color: SLATE } as const;

interface VerbaScholaAccountCardProps {
    title: string;
    intro?: ReactNode;
    width?: number;
    children?: ReactNode;
    /** Short help line under the card; defaults to the support address. */
    footer?: ReactNode;
}

// Shared layout for the public account pages (signup, forgot password, reset link, email
// verification): the brand-only header, then one card on the page background.
export default function VerbaScholaAccountCard({ title, intro, width = 440, children, footer }: VerbaScholaAccountCardProps) {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: PAGE_BACKGROUND }}>
            <VerbaScholaPublicHeader minimal />
            <Box component="main" sx={{ flex: 1, px: 2, py: { xs: 4, sm: 7 } }}>
                <Box sx={{ maxWidth: width, mx: 'auto' }}>
                    <Box sx={{ ...publicCardSx, p: { xs: 3, sm: 4 }, boxShadow: '0 10px 30px rgba(22, 58, 99, 0.06)' }}>
                        <Typography component="h1" sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 26, lineHeight: 1.25, color: NAVY }}>
                            {title}
                        </Typography>
                        {intro && <Typography sx={{ ...accountBodySx, mt: 1 }}>{intro}</Typography>}
                        {children}
                    </Box>
                    <Typography component="div" sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, textAlign: 'center', mt: 3 }}>
                        {footer ?? <>
                            Need help?{' '}
                            <Link href={`mailto:${SUPPORT_EMAIL}`} underline="hover" sx={{ ...accountLinkSx, fontSize: 13 }}>{SUPPORT_EMAIL}</Link>
                        </>}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
